module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAJCAYAAADdA2d2AAAAfUlEQVQokbXSMQrCQBBA0beVjUWqFHYexNMklTfwGjmBZQgINqaxsE4lOZFpdiEBhQTWDwNbzPwZZpYlJWoE6wg4Y/8rocCAx0ph4o0eu2/CFz64bpQ+Y90tiQMOaHGKSSO6DdIax/i+o4ImdsoVl79NSuadzsl+/USWfzoBiPct73Qr8SwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Width.png
// module id = 15
// module chunks = 0